import uuid from "../../utils/uuid";

export default function makeCampaignTier() {
  return { id: uuid(), minSpend: 0, maxSpend: 0, gift: null };
}
